import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/proposition-bets-widget.module.scss";
import {PropositionBetsWidgetRowOptions} from "./option/proposition-bets-widget.row.options";
import {PropositionBetsWidgetRowProgressBar} from "./progress-bar/proposition-bets-widget.row.progress-bar";
import {PropositionBetsWidgetRowAthlete} from "./athlete/proposition-bets-widget.row.athlete";
import {PropositionBetsWidgetRowButton} from "./proposition-bets-widget.row.button";
import {PROPOSITION_BETS} from "../../proposition-bets-widgets.consts";

export const PropositionBetsWidgetRow = observer(({controller, row}) => {
  const {state} = controller;
  const {isEnded, game} = state;
  const {athleteId, lineTypeId} = row;

  const rowProps = {
    className: classNames(styles.row, {[styles.ended_row]: isEnded, [styles.clickable_row]: row.hasRecords}),
    onClick: () => row.hasRecords && controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick, {athleteId, lineTypeId, gameId: game.id})
  }

  const baseProps = {
    controller,
    row
  }

  return (
    <div {...rowProps}>
      <PropositionBetsWidgetRowAthlete row={row}/>
      <PropositionBetsWidgetRowOptions {...baseProps}/>
      <PropositionBetsWidgetRowProgressBar {...baseProps}/>
      <PropositionBetsWidgetRowButton {...baseProps}/>
    </div>
  )
});
